var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main_bg"}),_c('Header'),_c('br'),_c('div',{staticStyle:{"text-align":"center","color":"#ffffff","position":"relative","font-size":"10px"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('home.bottom_nav_2')))])]),_c('Bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }